import { createAction, props } from '@ngrx/store';
import { SearchForm } from 'src/app/core/models/itinerary.model';

export const SubmitSearchForm = createAction(
  '[Dashboard Page] Submit search form',
  props<{ searchForm: SearchForm }>()
);

export const LoadItinerary = createAction('[Dashboard Page] Load pnr success');
